export default {
  FULL_PRICE: 'FULL_PRICE',
  FULL_PRICE_FREE_KIDS_SATURDAY: 'FULL_PRICE_FREE_KIDS_SATURDAY',
  PREORDER: 'PREORDER',
  PREORDER_FREE_KIDS_SATURDAY: 'PREORDER_FREE_KIDS_SATURDAY',
  PRESALE: 'PRESALE',
  PRESALE_FREE_KIDS_SATURDAY: 'PRESALE_FREE_KIDS_SATURDAY',
};



// WEBPACK FOOTER //
// ./src/views/skidata/components/ticketStrategy.js